import Logger from '../lib/logger';

class ShopifyHostedVideoPlayer extends HTMLElement {
  #NAME = 'ShopifyHostedVideoPlayer';
  #abortController
  #observer
  #playBtn
  #video
  #videoMobile
  #currentVideo
  #videoContainer
  #isPlaying = false


  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    this.#playBtn = this.querySelector('theme-play-button');
    this.#video = this.querySelector('video.desktop');
    this.#videoMobile = this.querySelector('video.mobile');
    this.#videoContainer = this.querySelector('.theme-banner-hero__video');
    this.#currentVideo = this.#video;
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback`);
    if (this.#currentVideo.autoplay) this.#isPlaying = true;
    this.#addListeners();
    //
    this.#observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        /* console.log('entry.isIntersecting', entry.isIntersecting, 'isPlaying', this.#isPlaying) */
          if (entry.isIntersecting) {
            if (this.#currentVideo.paused && this.#isPlaying) {
              this.#currentVideo.play();
            }
          } else if (!this.#currentVideo.paused) {
            this.#currentVideo.pause();
            this.#isPlaying = true;
          }
      })
    })
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#abortController = null;
    this.#observer?.disconnect();
    this.#observer = null;
  }

  #addListeners() {
    Logger.info(`${this.#NAME} > #addListeners`);
    this.#abortController?.abort();
    this.#abortController = null;
    //
    this.#abortController = new AbortController();
    const { signal } =  this.#abortController;
    //
    if (this.#playBtn) {
      this.#playBtn.addEventListener('click', () => {
        this.#currentVideo.paused ? this.#currentVideo.play() : this.#currentVideo.pause();
      }, { signal });
    }
    //
    this.#currentVideo.addEventListener('playing', () => {
      if (this.#playBtn) this.#playBtn.dataset.playing = 'true';
      /* console.log('playing'); */
    }, { signal });
    this.#currentVideo.addEventListener('pause', () => {
      if (this.#playBtn) this.#playBtn.dataset.playing = 'false';
      /* console.log('pause'); */
    }, { signal });
    this.#currentVideo.addEventListener('ended', () => {
      this.#currentVideo.currentTime = 0;
      if (this.#isPlaying) this.#currentVideo.play();
    }, { signal });
    //
    /* console.log(this.#currentVideo, 'paused', this.#currentVideo.paused, 'autoplay', this.#currentVideo.autoplay); */
    if (this.#currentVideo.autoplay && this.#currentVideo.paused && this.#isPlaying) {
      this.#currentVideo.play();
    }
    //
    if (this.#videoMobile) {
      window.addEventListener('resize', () => this.#onResize(), { signal });
      this.#onResize();
    }
  }

  #onResize() {
    Logger.info(`${this.#NAME} > #onResize`);
    const nextVideo = window.innerWidth >= 1024 ? this.#video : this.#videoMobile;
    const inactiveVideo = nextVideo === this.#video ? this.#videoMobile : this.#video;

    inactiveVideo.pause();
    inactiveVideo.remove();

    if (this.#currentVideo === nextVideo) return;

    const currentTime = this.#currentVideo.readyState > 0 ? this.#currentVideo.currentTime : 0;
    if (!nextVideo.parentElement) this.#videoContainer.appendChild(nextVideo);
    this.#currentVideo = nextVideo;
    if (currentTime > 0 && nextVideo.readyState > 0) nextVideo.currentTime = currentTime;
    this.#addListeners();
  }

}

customElements.define('shopify-hosted-video-player', ShopifyHostedVideoPlayer);
